define(['./directives/select'], (select)=> {
    return angular.module('edge.platform.widgets.select', [])
        .directive('gwPlSelect', select);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/select/module.js